import { ConsoleSqlOutlined } from "@ant-design/icons";
import { axiosDelete, axiosGet, axiosPost, axiosPut } from "./ajaxServices";
import { urlCreateSalary, urlDeleteSalary, urlDuplicateSalary, urlGetSalary, urlGetSalaryByMonth, urlUpdateSalary } from "./CONSTANTS";


export function apiCreateSalary(data) {
  const url = urlCreateSalary;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("team_member_id", data.team_member_id);
  formData.append("description", data.description);
  formData.append("is_year_salary", data.is_year_salary);
  formData.append("month_salary", data.month_salary);
  formData.append("month_date", data.month_date);
  formData.append("year_date", data.year_date);
  formData.append("year_salary", data.year_salary);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const apiGetSalaryByMonthList = () => {
  const url = urlGetSalaryByMonth;
  return new Promise((resolve, reject) => {
    axiosGet(url)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export function apiDuplicateSalary(data) {
  const url = urlDuplicateSalary;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("team_member_id", data.team_member_id);
  formData.append("description", data.description);
  formData.append("is_year_salary", data.is_year_salary);
  formData.append("month_salary", data.month_salary);
  formData.append("month_date", data.month_date);
  formData.append("year_date", data.year_date);
  formData.append("year_salary", data.year_salary);
  
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function apiUpdateSalary(data) {
  const url = urlUpdateSalary;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("id", data.id);
  formData.append("team_member_id", data.team_member_id);
  formData.append("description", data.description);
  formData.append("is_year_salary", data.is_year_salary);
  formData.append("month_salary", data.month_salary);
  formData.append("month_date", data.month_date);
  formData.append("year_date", data.year_date);
  formData.append("year_salary", data.year_salary);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const apiGetSalary = () => {
  const url = urlGetSalary;
  return new Promise((resolve, reject) => {
    axiosGet(url)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export function apiDeleteSalary(id) {
  const url = urlDeleteSalary;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}